export default __webpack_public_path__ + "static/media/bajajLogo.81d58f7a.png";